import { isNotNil } from 'es-toolkit';

import { DashboardFilterCVAdminCustomFormValues } from 'src/components/dashboard/components/DashboardFilterCVAdmin/types';

import { DashboardFilterCVAdminCustomFilterType } from '../../DashboardFilterCVAdmin/constants';

export const getCompaniesNames = (customFilter: DashboardFilterCVAdminCustomFormValues) => {
  const companyNamesDictionary: Record<DashboardFilterCVAdminCustomFilterType, string[]> = {
    [DashboardFilterCVAdminCustomFilterType.Employer]: customFilter.filters.employer
      .map(item => item.displayName)
      .filter(isNotNil),
    [DashboardFilterCVAdminCustomFilterType.PEO]: customFilter.filters.PEO.map(
      item => item.displayName,
    ).filter(isNotNil),
  };

  return companyNamesDictionary;
};
